export enum EmployeeHoursStatus {
  NotApproved,
  Approved,
}
